import { useContext } from "react";
import { TabsModalContext, TabsModalContextI } from "../context/TabsModalContext";

export default function useModalTabs<T>() {
    // @ts-ignore - avoid breaking the application
    return useContext<TabsModalContextI<T>>(TabsModalContext);
}
